'use strict';

module.exports = require('./InputNumber');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-input-number/lib/index.js
 ** module id = 317
 ** module chunks = 0
 **/